
export default {
  faq: [
    { 
        name: "Dudas sobre Scrapy",
        items: [
            {
                title: "¿Por qué Scrapy no RPA?",
                body: "Scrapy “es a Data, como RPA es a tarea”. Scrapy cuenta con mayor velocidad (hasta 100 veces más rápido y seguro) por el paralelismo, y es menos agresivo que los RPA con el sitio web de destino."
            },
            {
                title: "¿Scrapy Serverless?",
                body: "La arquitectura ideal para “scrapear” sitio web es el serverless, por su menor costo y alta disponibilidad."
            },
            {
                title: "¿Es legal hacer Scrapy?",
                body: "Sí, es completamente legal. Scrapy solo lee sitios web de forma masiva. Información a la que, como usuario, tienes acceso libre, por lo tanto en todos los países es legal. Cabe mencionar que en la Unión Europea se deben cumplir los protocolos de la RGPD, normas cuyo contenido difiere de la extracción, y, más bien, se refieren al uso y almacenamiento de datos."
            },
            {
                title: "¿Todos los sitios son “scrapeables”?",
                body: "Hasta el momento, como PATLAB, no ha existido una web/proyecto cuyos datos sean imposibles de “scrapear''. Incluso, hemos resuelto realizar servicios con captchas, Akamai y verificadores WDR."
            },
        ] 
    },
   
  ],
};
